import http from '../_http'

const qna = {
  //default
  summary : (m) => { return http.get('manager/board/qna', m); },
  list : (m) => { return http.post('manager/board/qna/list', m); },
  detail : (m) => { return http.get(`manager/board/qna/${m.id}`); },

  //crud
  insert : (m) => { return http.post('manager/board/qna', m); },
  update : (m) => { return http.put('manager/board/qna', m); },
  delete : (m) => { return http.delete(`manager/board/qna/${m.id}`); },
}

export default qna

export { qna }